exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageHeader-module__page-header___24esj{display:flex;flex-direction:column;justify-content:flex-end;height:100%;padding:48px 0;gap:24px}.PageHeader-module__page-header___24esj h1,.PageHeader-module__page-header___24esj p{color:#fff}.PageHeader-module__page-header___24esj h1{text-decoration:underline;-webkit-text-decoration-color:#fff;text-decoration-color:#fff;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none;text-underline-offset:6px;text-decoration-thickness:6px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.PageHeader-module__page-header___24esj p{max-width:800px}", ""]);

// exports
exports.locals = {
	"page-header": "PageHeader-module__page-header___24esj"
};